export default __webpack_public_path__ + "static/iso-8e35fe1e863f2ee317aad82b0dee8dfd.png";